var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Master"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M15 0.75C15 0.335786 14.6642 0 14.25 0H8.92088C8.50667 0 8.17088 0.335786 8.17088 0.75V7.80327C8.17088 8.21748 8.50667 8.55327 8.92088 8.55327H14.25C14.6642 8.55327 15 8.21748 15 7.80327V0.75ZM0.75 0C0.335786 0 0 0.335786 0 0.75V4.4437C0 4.85792 0.335786 5.1937 0.75 5.1937H6.07912C6.49333 5.1937 6.82912 4.85792 6.82912 4.4437V0.75C6.82912 0.335786 6.49333 0 6.07912 0H0.75ZM6.82912 7.19673C6.82912 6.78252 6.49333 6.44673 6.07912 6.44673H0.75C0.335786 6.44673 0 6.78252 0 7.19673V14.25C0 14.6642 0.335786 15 0.75 15H6.07912C6.49333 15 6.82912 14.6642 6.82912 14.25V7.19673ZM15 10.5563C15 10.1421 14.6642 9.80629 14.25 9.80629H8.92088C8.50667 9.80629 8.17088 10.1421 8.17088 10.5563V14.25C8.17088 14.6642 8.50667 15 8.92088 15H14.25C14.6642 15 15 14.6642 15 14.25V10.5563Z",
    fill: "#1E6CB6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d5f9d5fa3c0326689264652f95c51973.svg";
export { ForwardRef as ReactComponent };